// ── Branding configuration ───────────────────────────────────────────────────
// Change COMPANY_NAME or LOGO_URL here and it applies across the entire app.
// Place the logo file in /public/branding/ and update LOGO_URL accordingly.

export const COMPANY_NAME = 'KGreen';
export const LOGO_URL     = '/branding/logo.png';
export const PORTAL_LABEL = 'Support Portal';
